import { PostType, State } from 'src/types';
import { useSelector } from 'react-redux';

export function useIsPoll(): boolean {
  const { postTypeId } = useSelector(({pages}: State) => pages.singlePost.post);
  return postTypeId === PostType.Poll;
}
